<template>
  <div>
    <van-nav-bar
      :class="{'nav-bar-border': border}"
      :title="title"
      left-arrow
      fixed
      :border="false"
      :z-index="99"
      :style="{ background: background }"
      @click-left="onClickLeft"
    >
      <div
        slot="left"
        class="nav-bar-left"
      >
        <van-icon
          class="nav-bar-left-icon"
          class-prefix="icon"
          name="iosarrowback"
          :size="$vw('25px')"
        />
        <div class="nav-bar-left-text">{{ leftText }}</div>
      </div>
      <slot v-if="!title" slot="title" name="title" />
      <slot slot="right" name="right" />
    </van-nav-bar>
    <div
      v-if="blank"
      class="nav-bar-blank"
    />
  </div>
</template>

<script>
import { NavBar } from 'vant'

export default {
  components: {
    [NavBar.name]: NavBar
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    leftText: {
      type: String,
      default: '返回'
    },
    border: {
      type: Boolean,
      default: true
    },
    blank: {
      type: Boolean,
      default: true
    },
    background: {
      type: String,
      default: '#fff'
    }
  },
  methods: {
    onClickLeft() {
      this.$emit('click-left')
    }
  }
}
</script>

<style scoped>
.nav-bar-border {
    border-bottom: 1px solid var(--light90);
}
.nav-bar-left {
    display: flex;
    height: 100%;
    align-items: center;
    color: var(--themeColor);
}
.nav-bar-left-icon {
    font-weight: 900;
    color: var(--themeColor);
}
.nav-bar-blank {
    width: 375px;
    height: 46px;
}
</style>
